import React from 'react';
import { Card } from 'antd';
import { getProductCount } from '../product/actions';

class ProductCount extends React.PureComponent{

	render(){

		const { loading, productCount } = this.state;

		return (
			<Card loading={loading}>
				{productCount} Product
			</Card>
		)
	}

	state = {
		loading: true,
		productCount: false
	}

	constructor(props){
		super(props);

		getProductCount()
			.then( res => {
				this.setState({ loading: false, productCount: res.data.count })
			})
	}



}

export default ProductCount;


// WEBPACK FOOTER //
// ./src/components/analytics/product-count.js